import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'sal_center': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'stacode': {
    title: '合同状态',
    type: 'select',
    equation: city,
    dictionary: 'A0048'
  }
}

export default {
  'cntrno': {
    title: '合同单号',
    type: 'input',
    equation: all,
    slot: true
  },
  'cnrtln': {
    title: '合同编号',
    type: 'input',
    equation: all,
    width: 140
  },
  'cntrname': {
    describe: true,
    title: '合同名称',
    type: 'select',
    equation: city,
    dictionary: 'A0051',
    width: 180
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'contr_year': {
    title: '合同年度',
    type: 'year',
    equation: city
  },
  'name1': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'customertype': {
    title: '客户类型'
  },
  'salcnter_des': {
    title: '营销单元'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'channel': {
    title: '渠道',
    type: 'select',
    equation: city,
    dictionary: 'A0050',
    slot: true,
    width: 200
  },
  'chfl': {
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    slot: true,
    width: 200
  },
  'sales_emp_name': {
    title: '业务员',
    type: 'input',
    equation: all
  },
  'status': {
    title: '合同状态',
    type: 'select',
    equation: city,
    dictionary: 'A0048'
  },
  'cotr_qty': {
    title: '合同数量(单位：件数)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_amt': {
    title: '合同金额(单位：万元)',
    width: 180,
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_start': {
    title: '起始日期',
    type: 'date',
    equation: all
  },
  'cont_end': {
    title: '截止日期',
    type: 'date',
    equation: all
  },
  'cont_close': {
    title: '终止日期',
    type: 'date',
    equation: all
  },
  'address': {
    title: '收货地址',
    type: 'input',
    equation: all
  },
  'approval_no': {
    title: '签约审批单号',
    type: 'input',
  },
  'uname': {
    title: '创建人',
    type: 'input',
    equation: all
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all
  }
}



// WEBPACK FOOTER //
// ./src/views/contract-manage/config/contractList.js